/**
 * @desc AJS compliant router function to handle migration routes
 * @param {angular.$stateProvider} $stateProvider - Angular stateprovider to handle states
 * @return {void}
 */
export function TagsRouter($stateProvider) {
  'ngInject';

  $stateProvider.state('app.tags', {
    url: '/tags',
    template: '<app-tags></app-tags>',
  });
}



// WEBPACK FOOTER //
// ./src/app/tags/tags.router.js